<template>
  <div class="d-flex align-center justify-center h-100">
    <div
      v-if="totemMode.data.on_hold_content"
      style="max-width: 600px"
    >
      <v-img
        v-if="totemMode.data.on_hold_content.brand_src"
        class="brand mb-5"
        :src="totemMode.data.on_hold_content.brand_src"
        aspect-ratio="1"
        width="100"
        height="100"
        style="border-radius: 50%; margin: 0 auto;"
      ></v-img>
      <h2
        class="mb-2 text-center"
        :style="`color: ${totemMode.data.on_hold_content.text_color}`"
        v-html="totemMode.data.on_hold_content.title"
      ></h2>
      <h4
        class="font-weight-regular text-muted text-center"
        :style="`color: ${totemMode.data.on_hold_content.text_color}`"
        v-html="totemMode.data.on_hold_content.description"
      ></h4>
    </div>
    <div v-else style="max-width: 600px">
      Ingrese el contenido
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  computed: {
    totemMode () {
      return this.$organization.totemMode()
    }
  }
})
export default class OnHold extends Vue {}
</script>